module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('table', {
    staticClass: "table11"
  }, [_c('colgroup', [_c('col', {
    staticClass: "a30"
  }), _vm._v(" "), _c('col', {
    staticClass: "a70"
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AAA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Anti-Aircraft Artillery")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AMU")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Air Maintenance Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CASEVAC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Casualty Evacuation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EGAF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Egypt Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EGDF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Egypt Defense Force (armed forces/army)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EGNF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Egypt Naval Force (Navy)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FRUS")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Foreign Relations of the United States, a publication that constitutes the official record of the foreign policy of USA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("GMT")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Greenwich Mean Time")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("HQ")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILAF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Israel Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILAFI")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("ILAF Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Israel Defense Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF Front A")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("HQ north sector facing Lebanon, Syria and Iraq")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF Front B")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("HQ Samaria sector facing Iraq and Jordan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF Front C")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("HQ Judea sector facing Jordan and Egypt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF Front D")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("HQ south sector facing Egypt and Jordan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILDF G Branch")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("General Staff Branch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILFM")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Israel Foreign Minister")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILNF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Israel Naval Force (Navy)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ILPM")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Israel Prime Minister")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("OPOR")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Operation Order")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ORBAT")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Order of Battle")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Personal Collection")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PXNE")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phoenix over the Nile, a history of Egyptian air power 1932-1994")]), _vm._v(", Lon Nordeen and David Nicolle, 1996")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RAF")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Royal Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RTB")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Return to Base")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TOT")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Time On Target")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("UK")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("United Kingdom")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("UN")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("United Nations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("USA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("United States of America")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("USSR")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Union of Soviet Socialist Republics")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35503469","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Glossary.vue
// module id = 75
// module chunks = 0